import styled from "styled-components";

interface Props {
  bold?: boolean;
  semibold?: boolean;
  fontSize?:
    | "xxxl"
    | "xxyl"
    | "xxl"
    | "xl"
    | "lg"
    | "mdl"
    | "base"
    | "md"
    | "sm"
    | "xs"
    | "xxs"
    | "xxxs";
}

export const LinkStyled = styled.a<Props>`
  font-weight: ${(props) =>
    props.bold ? "bold" : props.semibold ? "600" : "normal"};

  font-size: ${({ theme, fontSize }) => theme.fontSize[fontSize || "md"]};

  &:hover {
    text-decoration: underline;
    color: #000;
  }
`;
